export enum DatePickerType {
  CheckIn = 'checkIn',
  CheckOut = 'checkOut'
}

export interface DatePickerState {
  checkIn: string
  checkOut: string
  datePickerFocus?: DatePickerType
}
